// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"130":"50d54974","266":"190dcebc","326":"a921fd50","406":"f1973a6e","453":"9ad9e819","686":"bc1513c0"}[chunkId] + ".chunk.js";
};